import React from "react";
import {Typography} from "antd";
import {Translate} from "../../../../../hooks/translate.hook";
import {HealthCheckerGroup} from "../../../../../models/health-checker/health-checker";
import {SmartColumn} from "../../../../common/smart-table/smart-table.model";
import {FieldType} from "../../../../common/smart-table/smart-table.field-config";
import {HealthCheckerGroupMembers} from "./check-groups.members";

const {Text} = Typography;

export const columnsFactory = (t: Translate): SmartColumn<HealthCheckerGroup>[] => {
    return [
        {
            name: "name",
            visibleName: t("HEALTH-CENTER.SETTINGS.CHECK-GROUPS.NAME", {defaultValue: "Group name"}),
            type: FieldType.STRING,
            filterable: true,
            render: (name: string) => <Text strong>{name}</Text>,
        },
        {
            name: "members",
            visibleName: t("HEALTH-CENTER.SETTINGS.CHECK-GROUPS.MEMBERS", {defaultValue: "Members"}),
            type: FieldType.CUSTOM_ARRAY,
            render: (members) => <HealthCheckerGroupMembers members={members} />,
        },
    ];
};
